import React from "react";

import ExtraCostView from "../../components/ExtraCosts/ExtraCostView";

const ExtraCostPage: React.FC<{}> = (props) => {
  return <ExtraCostView />;
};
export default ExtraCostPage;
